import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";
import { AppUnderlinedTitle } from "../../../../shared/components/AppUnderlinedTitle";
import { generateSkillMd } from "../../helpers/generateSkillMd";
import { selectSkillValue } from "../../redux/selectors";
import { DownloadFileButton } from "../../../../common/Components/Buttons/DownloadFileButton";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useFileTransferModal } from "../../../Modals/FileTransferModal/hook/use-file-transfer-modal";
import { FileTransferModal } from "../../../Modals/FileTransferModal";
import { useStorageSelectors } from "../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import styles from "./styles.module.css";

export const SkillsResult = () => {
  const value = useAppSelector(selectSkillValue);
  const [preview, setPreview] = useState<string>("");
  const { selectedObject } = useStorageSelectors("skills");
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const { handleClick } = useFileTransferModal({
    name: `SKILL.md`,
    content: generateSkillMd(value?.skill_object),
  });

  useEffect(() => {
    if (value) {
      const md = generateSkillMd(value?.skill_object);
      setPreview(md);
    }
  }, [value]);

  return (
    <div className={styles["result-layout"]}>
      <AppUnderlinedTitle leftContent={"SKILL.md"}>
        <DownloadFileButton
          onDownload={() => handleOpenModal("file_transfer_modal", null)}
        />
      </AppUnderlinedTitle>
      <div className={styles["result-preview"]}>
        <AppMarkdownParser
          content={preview}
          className={styles["markdown-skill-parser"]}
        />
      </div>
      <FileTransferModal
        handleActions={handleClick}
        closeModal={handleCloseModal}
      />
    </div>
  );
};
